import axios from 'axios'
import { getAccessToken } from './auth-fn'
import VueCookies from 'vue-cookies'
import { appConfig } from './config-api'

function getToken () {
    if (typeof getAccessToken() !== null) {
        return getAccessToken()
    } else {
        VueCookies.get('token')
    }
}

function getAPIRoot () {
    return `${window.location.protocol}//${window.location.hostname}:${window.location.port}${appConfig.backendUrl}`
}

export const HTTP = axios.create({
    baseURL: getAPIRoot(),
    timeout: 30000,
    headers: {
        Authorization: `Bearer ${getToken()}`,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
    },
})
